module.exports = __webpack_public_path__ + "static/media/bg-groups.3def2c92.svg";